import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CurrentUser } from '@models/Core/CurrentUser';
import { AssetsPipe } from '@pipes/assets.pipe';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'profile-picture',
  standalone: true,
  imports: [CommonModule, AssetsPipe],
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnInit, OnDestroy {
  @Input() user: { profile_picture?: string };
  @Input() noMargin = false;
  @Input() size: 'small' | 'medium' = 'small';

  constructor(
    private auth: AuthenticationService,
    private bus: BusService,
    private events: EventsService,
  ) {}

  ngOnInit() {
    if (!this.user) {
      this.update();
      this.bus.subscribe(
        this.events.received.action.user.update.success,
        this.update,
        this,
      );
    }
  }

  ngOnDestroy() {
    this.bus.unsubscribe(
      this.events.received.action.user.update.success,
      this.update,
    );
  }

  update() {
    this.auth.getCurrentUser.subscribe(
      (user: CurrentUser) => (this.user = user),
    );
  }
}
